import Reactotron from 'reactotron-react-js';
import { reactotronRedux } from 'reactotron-redux';
import reactotronSaga from 'reactotron-redux-saga';

// Objeto mock para evitar erros quando Reactotron não está disponível
const mockTron = {
  log: () => {},
  warn: () => {},
  error: () => {},
  display: () => {},
  clear: () => {},
  createEnhancer: () => (f) => f,
  createSagaMonitor: null,
};

// Inicializa com mock primeiro para evitar erros
console.tron = mockTron;

// Permite desabilitar Reactotron via variável de ambiente
// Adicione REACT_APP_REACTOTRON_DISABLED=true no .env para desabilitar
const isReactotronDisabled = process.env.REACT_APP_REACTOTRON_DISABLED === 'true';

if (process.env.NODE_ENV === 'development' && !isReactotronDisabled) {
  try {
    const tron = Reactotron.configure({
      host: 'localhost',
      port: 9090,
    })
      .use(reactotronRedux())
      .use(reactotronSaga())
      .connect();

    tron.clear();
    // Substitui o mock pelo Reactotron real quando conecta com sucesso
    console.tron = tron;
  } catch (error) {
    // Mantém o mock se houver erro na inicialização
    // O erro de WebSocket no console é esperado quando Reactotron não está rodando
    // Para usar o Reactotron, execute: npx reactotron (ou instale o app Reactotron)
    // Para desabilitar completamente, adicione REACT_APP_REACTOTRON_DISABLED=true no .env
  }
}
